import { Auth0Provider as Provider } from '@auth0/auth0-react';
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import {
  AUTH0_AUDIENCE,
  AUTH0_CLIENT_ID,
  AUTH0_DOMAIN,
  URLS
} from '../../utils/constants';

const redirectUri = `${window.location.origin}${URLS.LOGIN_CALLBACK}/`;

const AuthProvider = ({ children }) => {
  const history = useHistory();

  // Auth0 always redirects to /login/callback after authentication
  // This gets the originally requested URL from appState, or defaults to '/'
  const handleRedirectCallback = (appState) => {
    const redirectTo = appState?.returnTo || '/';
    history.replace(redirectTo);
  };

  return (
    <Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      onRedirectCallback={handleRedirectCallback}
      cacheLocation="memory"
      useRefreshTokens
      authorizationParams={{
        audience: AUTH0_AUDIENCE,
        redirect_uri: redirectUri
      }}
    >
      {children}
    </Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default AuthProvider;
